import { render } from "./YellowPage.vue?vue&type=template&id=7c319da9&scoped=true"
import script from "./YellowPage.vue?vue&type=script&lang=js"
export * from "./YellowPage.vue?vue&type=script&lang=js"

import "./YellowPage.vue?vue&type=style&index=0&id=7c319da9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c319da9"]])

export default __exports__